/** Día civil Food Plan (Bogotá). No usar toISOString().slice(0,10). */
export const FOOD_CIVIL_TZ = 'America/Bogota'

export function foodCivilToday(): string {
  return new Date().toLocaleDateString('en-CA', { timeZone: FOOD_CIVIL_TZ })
}

export function addFoodCivilDays(dateStr: string, delta: number): string {
  const m = String(dateStr || '').match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!m) return foodCivilToday()
  const y = Number(m[1])
  const mo = Number(m[2])
  const d = Number(m[3])
  return new Date(Date.UTC(y, mo - 1, d + delta)).toISOString().slice(0, 10)
}
